import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const organizationLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Galgame资源大全',
    url: 'https://galgame-resources.com',
    description: '最全面的中文galgame资源聚合平台，提供galgame资源下载导航、汉化补丁、推荐合集与新手入门指南。',
    sameAs: [
      'https://weibo.com/galgame-resources',
      'https://space.bilibili.com/galgame-resources',
    ],
  };

  const websiteLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Galgame资源大全',
    url: 'https://galgame-resources.com',
    description: '寻找优质galgame资源？Galgame资源大全汇聚海量galgame资源下载、汉化补丁、推荐合集与新手入门指南。',
    inLanguage: 'zh-CN',
  };

  const webpageLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Galgame资源大全 · 免费下载与推荐合集',
    description: '汇聚海量galgame资源下载、汉化补丁、推荐合集与新手入门指南，涵盖经典与新作。',
    url: 'https://galgame-resources.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Galgame资源大全',
      url: 'https://galgame-resources.com',
    },
  };

  return (
    <>
      <SEOHead
        title="Galgame资源大全 · 免费下载与推荐合集 | galgame资源下载导航"
        description="寻找优质galgame资源？Galgame资源大全汇聚海量galgame资源下载、汉化补丁、推荐合集与新手入门指南，涵盖经典与新作，帮你快速找到心仪的galgame资源，告别搜索烦恼。"
        keywords="galgame资源,galgame资源下载,galgame汉化资源,免费galgame资源合集,galgame资源推荐,galgame资源网站,galgame新手资源入门"
        canonicalUrl="https://galgame-resources.com/"
      />
      <SchemaOrg type="Organization" data={organizationLd} />
      <SchemaOrg type="WebSite" data={websiteLd} />
      <SchemaOrg type="WebPage" data={webpageLd} />

      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}